import Api from '../../../api/configuration'

const BroadcastClassApis = {
  askQuestion: (id, type, question) =>
    Api.coreProtected.post(`broadcast-class/${type}/${id}/question`, {
      question,
    }),
  deleteQuestion: (id, type, questionId) =>
    Api.coreProtected.delete(
      `broadcast-class/${type}/${id}/question/${questionId}`,
    ),
  endLiveChat: (id, type) =>
    Api.slsCoreProtected.delete(
      `broadcast-class/id/${id}/type/${type}/live-chat/request/end`,
    ),
  getRecordingFile: (id) =>
    Api.coreProtected.get(`util/recording/${id}/playback`),
  grantOrDenyRequest: (classId, type, requestId, grant) =>
    Api.coreProtected.put(
      `broadcast-class/id/${classId}/type/${type}/live-chat/request`,
      {
        grant,
        liveRequestId: requestId,
      },
    ),
  lowerHand: (id, type) =>
    Api.slsCoreProtected.delete(
      `broadcast-class/id/${id}/type/${type}/live-chat/request`,
    ),
  purchaseRecording: (bcType, id) =>
    Api.coreProtected.post(`broadcast-class/${bcType}/recording/purchase`, {
      broadcastClassId: id,
    }),
  raiseHand: (id, type) =>
    Api.slsCoreProtected.post(
      `broadcast-class/id/${id}/type/${type}/live-chat/request`,
    ),
  register: (livdemyId, bcType, id) =>
    Api.coreProtected.post(`${livdemyId}/broadcast-class/${bcType}/register`, {
      broadcastClassId: id,
    }),
  registerSeries: (bcType, id) =>
    Api.coreProtected.post(`series/register/${bcType}`, { seriesId: id }),
}

export default BroadcastClassApis
